import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { AdsTypeListDatatableComponent } from './components/ads-type-list-datatable/ads-type-list-datatable.component';

const DECLARATIONS = [AdsTypeListDatatableComponent];

const MODULES = [SharedModule];

@NgModule({
  declarations: DECLARATIONS,
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class AdsTypeModule {}
